document.addEventListener('DOMContentLoaded', function () {
  // 1. 全局共用配置
  const apiBase = 'https://api.ashimarywig.com'

  // 2. 全局数据请求缓存 (只请求一次 fifacfg)
  let globalTeamsPromise = null;

  function getGlobalTeamsData() {
    if (!globalTeamsPromise) {
      globalTeamsPromise = fetch(`${apiBase}/api/activity/fifacfg`)
        .then((response) => response.json())
        .then((res) => {
          if (res.code === 1 && res.data) return res.data;
          throw new Error('Failed to load teams data');
        });
    }
    return globalTeamsPromise;
  }

  // ====================================================================
  // 模块一：World Cup Support (原 world-cup-1.liquid)
  // ====================================================================
  const supportSections = document.querySelectorAll('[id^="wc-quiz-"]');
  supportSections.forEach((sectionContainer) => {
    // 🛡️ 核心修复：初始化锁。如果这个模块已经初始化过，直接跳过，防止重复绑定！
    if (sectionContainer.dataset.jsInitialized === 'true') return;
    sectionContainer.dataset.jsInitialized = 'true';

    const cardsContainer = sectionContainer.querySelector('.wc-cards-slider');
    const selectMenu = sectionContainer.querySelector('.wc-team-select');
    const hiddenInput = sectionContainer.querySelector('#wc-selected-team-input');
    const prevBtn = sectionContainer.querySelector('.wc-prev-arrow');
    const nextBtn = sectionContainer.querySelector('.wc-next-arrow');
    const quizForm = sectionContainer.querySelector('.wc-quiz-form');
    const errorModal = sectionContainer.querySelector('#wc-error-modal');
    const modalClose = sectionContainer.querySelector('.wc-modal-close');
    const successModal = sectionContainer.querySelector('#wc-success-modal');
    const successModalClose = successModal ? successModal.querySelector('.wc-modal-close') : null;
    const modalCodeDisplay = successModal ? successModal.querySelector('#wc-modal-code-display') : null;
    const modalCopyBtn = successModal ? successModal.querySelector('#wc-modal-copy-btn') : null;
    const couponBanner = sectionContainer.querySelector('.wc-coupon-banner');
    const copyBtn = sectionContainer.querySelector('.wc-copy-btn');

    const cachedCode = localStorage.getItem('wc_worldcup_discount');
    if (cachedCode) {
      updateCoupon(cachedCode);
      if(couponBanner) couponBanner.style.display = 'flex';
    }

    if (modalClose) modalClose.addEventListener('click', () => (errorModal.style.display = 'none'));
    if (successModalClose) successModalClose.addEventListener('click', () => (successModal.style.display = 'none'));
    
    function triggerConfetti() {
      const colors = ['#00a8b5', '#028090', '#f0e1cc', '#000000', '#ffffff'];
      for (let i = 0; i < 60; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'wc-confetti';
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.left = Math.random() * 100 + 'vw';
        confetti.style.width = Math.random() * 8 + 5 + 'px';
        confetti.style.height = confetti.style.width;
        confetti.style.animationDuration = Math.random() * 2 + 2 + 's';
        confetti.style.opacity = Math.random();
        document.body.appendChild(confetti);
        setTimeout(() => confetti.remove(), 4000);
      }
    }

    if (modalCopyBtn) {
      modalCopyBtn.addEventListener('click', function () {
        const code = modalCodeDisplay.textContent;
        navigator.clipboard.writeText(code).then(() => {
          this.textContent = 'COPIED!';
          setTimeout(() => {
            successModal.style.display = 'none';
            this.textContent = 'COPY & SHOP NOW';
          }, 1000);
        });
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        const codeToCopy = this.dataset.code;
        if (!codeToCopy) return;
        navigator.clipboard.writeText(codeToCopy).then(() => {
          const span = this.querySelector('span');
          const oldText = span.textContent;
          span.textContent = 'Copied!';
          setTimeout(() => { span.textContent = oldText; }, 2000);
        });
      });
    }

    getGlobalTeamsData()
      .then((data) => {
        renderTeams(data.country_list);
        updateCoupon(data.discount_code);
        initSelectionLogic();
      })
      .catch((err) => console.error('Support Module - Error fetching config:', err));

    if (quizForm) {
      quizForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const emailInput = this.querySelector('input[name="contact[email]"]');
        const privacyCheckbox = this.querySelector('.wc-privacy-checkbox');
        const email = emailInput ? emailInput.value : '';
        const countryCode = hiddenInput ? hiddenInput.value : '';
        const privacyChecked = privacyCheckbox ? privacyCheckbox.checked : false;

        if (!email || !countryCode || !privacyChecked) return;

        const submitBtn = this.querySelector('.wc-submit-btn');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        fetch(`${apiBase}/api/activity/fifasub`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, code: countryCode, source: 'select_team' }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.code === 1) {
              const newCode = res.data.discount_code;
              localStorage.setItem('wc_worldcup_discount', newCode);
              localStorage.setItem('worldcup_support_email', email);
              if(setEmailLocalStorage){
                setEmailLocalStorage(email)
              }
              updateCoupon(newCode);
              if (modalCodeDisplay) modalCodeDisplay.textContent = newCode;
              if (couponBanner) couponBanner.style.display = 'flex';
              if (successModal) successModal.style.display = 'flex';
              triggerConfetti();
            } else if (errorModal) {
              errorModal.style.display = 'flex';
            }
          })
          .catch((err) => console.error('Sub error:', err))
          .finally(() => {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Get Team Code Now';
          });
      });
    }

    function renderTeams(list) {
      if (!list || !list.length || !cardsContainer || !selectMenu) return;
      let cardHtml = '';
      let optionHtml = '';
      list.forEach((item, index) => {
        const countryName = item.country_code.toUpperCase();
        cardHtml += `
          <div class="wc-card" data-index="${index}" data-code="${item.country_code}">
            <div class="wc-flag-box">
              <img src="${item.flag_path}" alt="${countryName}" loading="lazy" width="120">
            </div>
            <div class="wc-team-name">${countryName}</div>
          </div>`;
        optionHtml += `<option value="${index}" data-code="${item.country_code}">${countryName}</option>`;
      });
      cardsContainer.innerHTML = cardHtml;
      selectMenu.innerHTML = optionHtml;
    }

    function updateCoupon(code) {
      const couponCodeEl = sectionContainer.querySelector('.wc-coupon-code');
      const targetCopyBtn = sectionContainer.querySelector('.wc-copy-btn');
      if (couponBanner) {
        couponBanner.style.setProperty('--wc-bg-img', `url('${couponBanner.dataset.bgMb}')`);
        couponBanner.style.setProperty('--wc-bg-img-pc', `url('${couponBanner.dataset.bgPc}')`);
      }
      if (couponCodeEl) couponCodeEl.textContent = code;
      if (targetCopyBtn) targetCopyBtn.dataset.code = code;
    }

    function initSelectionLogic() {
      const allCards = sectionContainer.querySelectorAll('.wc-card');
      allCards.forEach((card) => {
        card.addEventListener('click', function () { updateActiveSelection(this.dataset.index); });
      });
      if (selectMenu) {
        selectMenu.addEventListener('change', function () { updateActiveSelection(this.value); });
      }
      updateActiveSelection(0);
    }

    function updateActiveSelection(index) {
      const targetIdx = parseInt(index);
      const allCards = sectionContainer.querySelectorAll('.wc-card');
      if (isNaN(targetIdx) || targetIdx < 0 || targetIdx >= allCards.length) return;

      allCards.forEach((card) => card.classList.remove('is-active'));
      const targetCard = sectionContainer.querySelector(`.wc-card[data-index="${targetIdx}"]`);

      if (targetCard) {
        targetCard.classList.add('is-active');
        const teamCode = targetCard.getAttribute('data-code');
        if (hiddenInput) hiddenInput.value = teamCode;
        if (selectMenu && selectMenu.value !== targetIdx.toString()) {
          selectMenu.value = targetIdx;
        }
        if (cardsContainer) {
            const containerWidth = cardsContainer.clientWidth;
            const cardOffset = targetCard.offsetLeft;
            const cardWidth = targetCard.offsetWidth;
            cardsContainer.scrollTo({
            left: cardOffset - containerWidth / 2 + cardWidth / 2,
            behavior: 'smooth',
            });
        }
        if (prevBtn && nextBtn) {
          prevBtn.disabled = targetIdx === 0;
          nextBtn.disabled = targetIdx === allCards.length - 1;
        }
      }
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        const activeCard = sectionContainer.querySelector('.wc-card.is-active');
        const currIdx = activeCard ? parseInt(activeCard.dataset.index) : 0;
        if (currIdx > 0) updateActiveSelection(currIdx - 1);
      });
      nextBtn.addEventListener('click', () => {
        const activeCard = sectionContainer.querySelector('.wc-card.is-active');
        const currIdx = activeCard ? parseInt(activeCard.dataset.index) : 0;
        const allCards = sectionContainer.querySelectorAll('.wc-card');
        if (currIdx < allCards.length - 1) updateActiveSelection(currIdx + 1);
      });
    }
  });


  // ====================================================================
  // 模块二：World Cup Prediction (原 world-cup-3.liquid)
  // ====================================================================
  
  function getGlowRGB(countryCode) {
    const mapping = {
      ARG: '116, 172, 223', BRA: '255, 223, 0', FRA: '0, 35, 149', GER: '255, 206, 0', 
      ESP: '170, 21, 27', ENG: '206, 17, 38', POR: '0, 102, 0', ITA: '0, 140, 69', 
      NED: '255, 79, 0', BEL: '255, 205, 0', CRO: '238, 33, 46', MAR: '193, 39, 45', 
      JPN: '188, 0, 45', KOR: '205, 43, 61', USA: '0, 40, 104', MEX: '0, 104, 71',
      URU: '116, 180, 225', COL: '252, 209, 22', CHI: '196, 21, 28', ECU: '255, 221, 0',
      CAN: '255, 0, 0', SEN: '250, 201, 16', TUN: '233, 27, 27', NGA: '0, 134, 63', 
      GHA: '254, 203, 0', IRN: '34, 150, 81', KSA: '1, 121, 71', AUS: '255, 204, 0',
      SUI: '255, 0, 0', DEN: '200, 16, 46', POL: '220, 20, 60', SRB: '198, 54, 60', 
      AUT: '237, 41, 57', SWE: '0, 106, 167', NOR: '239, 43, 45', TUR: '227, 10, 23',
      UKR: '0, 87, 184', CZE: '17, 69, 140', CRC: '206, 17, 38', PAN: '1, 33, 105', 
      JAM: '252, 209, 22', CIV: '255, 150, 0', EGY: '206, 17, 38', CMR: '0, 122, 61', 
      QAT: '138, 25, 48', IRQ: '0, 114, 41'
    };
    return mapping[countryCode.toUpperCase()] || '10, 130, 118';
  }

  const predictionSections = document.querySelectorAll('div[id^="wcp-"]');
  predictionSections.forEach((section) => {
    // 规避匹配到内部子元素
    if (section.id.includes('voting-state') || section.id.includes('result-state')) return;

    // 🛡️ 核心修复：初始化锁。防止同一个预测模块被重复绑定事件
    if (section.dataset.jsInitialized === 'true') return;
    section.dataset.jsInitialized = 'true';

    const sectionId = section.id.replace('wcp-', '');
    const CACHE_KEY = `wc3_predicted_team_cache_${sectionId}`;

    const middleRow = section.querySelector('.wcp-middle-row');
    const sliderSection = section.querySelector('.wcp-slider-section');
    const privacyLabel = section.querySelector('.wcp-privacy');
    const resultState = document.getElementById(`wcp-result-state-${sectionId}`);
    const modalWrapper = document.getElementById(`wc3-success-modal-${sectionId}`);
    const track = document.getElementById(`wcp-dynamic-track-${sectionId}`);
    const predictionForm = document.getElementById(`wcp-form-${sectionId}`);
    const selectMenu = document.getElementById(`wcp-dynamic-select-${sectionId}`);
    const hiddenInputCode = document.getElementById(`wcp-selected-team-${sectionId}`);
    const hiddenInputFlag = document.getElementById(`wcp-selected-flag-${sectionId}`);
    const submitBtn = document.getElementById(`wcp-submit-btn-${sectionId}`);
    const emailInput = document.getElementById(`wcp-email-${sectionId}`);
    const agreeCheckbox = document.getElementById(`wcp-agree-${sectionId}`);

    const errorModal_p = document.getElementById('wcp-error-modal');
    const modalClose_p = document.querySelector('.wcp-modal-close');

    if (modalClose_p && errorModal_p) {
        modalClose_p.addEventListener('click', () => {
            errorModal_p.style.display = 'none';
        });
    }

    initCountdown();

    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      showResultState(parsed, parsed.email);
    } else {
      getGlobalTeamsData()
        .then((data) => {
          if (data && data.country_list && data.country_list.length > 0) {
            renderTeams(data.country_list);
          } else {
            if(track) track.innerHTML = '<div style="color:red; padding: 20px;">Failed to load teams.</div>';
          }
        })
        .catch((err) => {
          console.error('Prediction Module - Error:', err);
          if(track) track.innerHTML = '<div style="color:red; padding: 20px;">Network error.</div>';
        });
    }

    function renderTeams(countryList) {
      if(!track || !selectMenu) return;
      track.innerHTML = '';
      selectMenu.innerHTML = '';

      countryList.forEach((item, index) => {
        const countryName = item.country_code.toUpperCase();
        const option = document.createElement('option');
        option.value = index;
        option.dataset.code = item.country_code;
        option.dataset.flag = item.flag_path;
        option.textContent = countryName;
        selectMenu.appendChild(option);

        const card = document.createElement('div');
        card.className = `wcp-card ${index === 0 ? 'is-active' : ''}`;
        card.dataset.index = index;
        card.dataset.code = item.country_code;
        card.dataset.flag = item.flag_path;
        card.innerHTML = `
          <img src="${item.flag_path}" class="wcp-flag" alt="${countryName}">
          <div class="wcp-team-name">${countryName}</div>
        `;
        track.appendChild(card);
      });
      initSliderAndEvents();
    }

    function initSliderAndEvents() {
      const cards = section.querySelectorAll('.wcp-card');
      const prevBtn = section.querySelector('.wcp-arrow.prev');
      const nextBtn = section.querySelector('.wcp-arrow.next');

      function updateSelection(index) {
        const idx = parseInt(index);
        if (isNaN(idx) || idx < 0 || idx >= cards.length) return;

        cards.forEach((c) => c.classList.remove('is-active'));
        const targetCard = section.querySelector(`.wcp-card[data-index="${idx}"]`);
        
        if (targetCard) {
          targetCard.classList.add('is-active');
          if(hiddenInputCode) hiddenInputCode.value = targetCard.getAttribute('data-code');
          if(hiddenInputFlag) hiddenInputFlag.value = targetCard.getAttribute('data-flag');
          
          if(track) {
            const trackWidth = track.clientWidth;
            const cardLeft = targetCard.offsetLeft;
            const cardWidth = targetCard.offsetWidth;
            track.scrollTo({ left: cardLeft - trackWidth / 2 + cardWidth / 2, behavior: 'smooth' });
          }
          
          if (prevBtn) prevBtn.disabled = idx === 0;
          if (nextBtn) nextBtn.disabled = idx === cards.length - 1;
        }

        if (selectMenu && selectMenu.value !== String(idx)) {
          selectMenu.value = idx;
        }
      }

      cards.forEach((card) => {
        card.addEventListener('click', function () { updateSelection(this.getAttribute('data-index')); });
      });
      
      if (selectMenu) {
        selectMenu.addEventListener('change', function () { updateSelection(this.value); });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const activeCard = section.querySelector('.wcp-card.is-active');
          const currIdx = activeCard ? parseInt(activeCard.getAttribute('data-index')) : 0;
          if (currIdx > 0) updateSelection(currIdx - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const activeCard = section.querySelector('.wcp-card.is-active');
          const currIdx = activeCard ? parseInt(activeCard.getAttribute('data-index')) : 0;
          if (currIdx < cards.length - 1) updateSelection(currIdx + 1);
        });
      }
      updateSelection(0);
    }

    if (predictionForm) {
      predictionForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const email = emailInput ? emailInput.value.trim() : '';
        const code = hiddenInputCode ? hiddenInputCode.value : '';
        const flagUrl = hiddenInputFlag ? hiddenInputFlag.value : '';

        if (!code) return;

        if(submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }

        try {
          const payload = { email: email, code: code, source: 'country_win' };
          const response = await fetch(`${apiBase}/api/activity/fifasub`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const res = await response.json();

          if (res.code === 1) {
            const finalCountryName = res.data && res.data.country_code ? res.data.country_code.toUpperCase() : code.toUpperCase();
            if(modalWrapper) {
                const modalResultText = modalWrapper.querySelector('.wc3-modal-result-text');
                if (modalResultText) modalResultText.textContent = finalCountryName;
            }

            const selectedTeamInfo = { name: finalCountryName, flagUrl: flagUrl, email: email };
            localStorage.setItem(CACHE_KEY, JSON.stringify(selectedTeamInfo));
            localStorage.setItem('worldcup_predict_email', email);
            if(setEmailLocalStorage){
                setEmailLocalStorage(email)
              }
            if (modalWrapper) modalWrapper.classList.add('is-open');
          }else if (errorModal_p) {
            errorModal_p.style.display = 'flex';
          }
        } catch (error) {
          console.error('Submit error:', error);
        } finally {
          if(submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit the forecast';
          }
        }
      });
    }

    if (modalWrapper) {
      const closeBtns = modalWrapper.querySelectorAll('.wc3-close-btn');
      closeBtns.forEach((btn) =>
        btn.addEventListener('click', () => {
          modalWrapper.classList.remove('is-open');
          const savedData = JSON.parse(localStorage.getItem(CACHE_KEY));
          if (savedData) showResultState(savedData, savedData.email);
        })
      );
    }

    function showResultState(teamData, email) {
      if (middleRow) middleRow.classList.add('is-hidden');
      if (sliderSection) sliderSection.classList.add('is-hidden');
      if (privacyLabel) privacyLabel.classList.add('is-hidden');

      if (emailInput) {
        emailInput.value = email || '';
        emailInput.disabled = true;
      }
      if (agreeCheckbox) {
        agreeCheckbox.checked = true;
        agreeCheckbox.disabled = true;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitted';
      }

      setTimeout(() => {
        if (resultState) {
          resultState.classList.add('is-active');

          const glowEl = resultState.querySelector('.wc3-flag-glow');
          if (glowEl && teamData.name) {
            glowEl.style.setProperty('--wcp-glow-rgb', getGlowRGB(teamData.name));
          }

          const flagImg = document.getElementById(`wc3-result-flag-${sectionId}`);
          const titleEl = document.getElementById(`wc3-result-title-${sectionId}`);
          const nameEl = document.getElementById(`wc3-result-name-${sectionId}`);
          
          if (flagImg && teamData.flagUrl) {
            flagImg.src = teamData.flagUrl;
            flagImg.alt = teamData.name;
          }
          if (nameEl && teamData.name) {
            nameEl.textContent = teamData.name;
          }
          if (titleEl && teamData.name) {
            titleEl.textContent = `Your choice is ${teamData.name}`;
          }
        }
      }, 300);
    }

    function initCountdown() {
      const timerElement = section.querySelector('.wcp-countdown');
      if (!timerElement) return;
      const targetDateStr = timerElement.getAttribute('data-target');
      const targetTime = new Date(targetDateStr).getTime();

      if (!isNaN(targetTime)) {
        const dEl = timerElement.querySelector('.d');
        const hEl = timerElement.querySelector('.h');
        const mEl = timerElement.querySelector('.m');

        const updateTimer = () => {
          const now = new Date().getTime();
          const distance = targetTime - now;
          if (distance < 0) {
            if(dEl) dEl.innerText = '0d';
            if(hEl) hEl.innerText = '0h';
            if(mEl) mEl.innerText = '0m';
            return;
          }
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          if(dEl) dEl.innerText = days + 'd';
          if(hEl) hEl.innerText = hours + 'h';
          if(mEl) mEl.innerText = minutes + 'm';
        };
        updateTimer();
        setInterval(updateTimer, 1000);
      }
    }
  });
});